import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  evaluateCVStart,
  evaluateCVSuccess,
  evaluateCVFailed,
} from "../redux/evaluateCV";
import { toast } from "react-toastify";
import { evaluateCVApi } from "core/http/service/evaluation";
import {
  getCvOfCampaignStart,
  resetCvOfCampaign,
} from "../redux/getCvofCampaign";
import { getInfoSelectedCandidateStart } from "../redux/getInfoSelectedCandidate";

function* evaluateCVWork(action: ReturnType<typeof evaluateCVStart>) {
  try {
    const { callback, ...rest } = action.payload;

    const res = yield call(evaluateCVApi, rest);
    yield put({
      type: evaluateCVSuccess.type,
      payload: {
        data: res.data,
      },
    });

    yield put({
      type: resetCvOfCampaign.type,
    });

    yield put({
      type: getCvOfCampaignStart.type,
      payload: {
        screenCode: rest.screenCode,
        programCode: rest.itemCode,
        reviewCvId: rest.reviewCvId,
      },
    });

    yield put({
      type: getInfoSelectedCandidateStart.type,
      payload: {
        screenCode: rest.screenCode,
        applyInfoId: rest.applyInfoId,
        programCode: rest.itemCode,
      },
    });

    toast.success("Đánh giá CV thành công!");

    if (callback) {
      callback();
    }
  } catch (error: any) {
    yield put({
      type: evaluateCVFailed.type,
    });
    toast.error(error?.response?.data?.message || "Đánh giá các CV thất bại!");
  }
}

function* watchEvaluateCV() {
  yield takeLatest(evaluateCVStart.type, evaluateCVWork);
}

export default function* evaluateCVSaga() {
  yield all([watchEvaluateCV()]);
}
